module.exports = __webpack_public_path__ + "static/media/luggage_warning.418c661c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/luggage_warning.svg
// module id = 593
// module chunks = 0